/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Runda 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gihara": ["Bikimba", "Bimba", "Kabasanza", "Nyagatare", "Rukaragata", "Ruyigi"],
  "Kabagesera": ["Bwirabo", "Kabagesera", "Muhambara", "Rubuye", "Rugogwe"],
  "Kagina": ["Gasharara", "Kagina", "Kamuhoza", "Kigusa", "Rugarama"],
  "Muganza": ["Kigabiro", "Musebeya", "Nyagacyamu", "Nyaruhoko", "Rubona"],
  "Ruyenzi": ["Kibaya", "Nyabitare", "Nyagacaca", "Rubumba", "Rugazi"]
};